<script setup>
import { computed } from 'vue';
import { hasValue } from '../helpers';

const props = defineProps({
  // [{ key, label, value, href, mono, wide }]
  items: { type: Array, default: () => [] },
});

const visibleItems = computed(() =>
  props.items.filter(item => hasValue(item.value))
);
</script>

<template>
  <dl
    v-if="visibleItems.length"
    class="grid grid-cols-2 gap-x-4 gap-y-2 m-0 sm:grid-cols-3"
  >
    <div
      v-for="item in visibleItems"
      :key="item.key"
      class="flex flex-col min-w-0 gap-0.5"
      :class="{ 'col-span-2 sm:col-span-3': item.wide }"
    >
      <dt class="text-[11px] uppercase tracking-wide text-n-slate-10">
        {{ item.label }}
      </dt>
      <dd
        class="m-0 text-xs text-n-slate-12 truncate"
        :title="String(item.value)"
      >
        <a
          v-if="item.href"
          :href="item.href"
          target="_blank"
          rel="noopener noreferrer"
          class="hover:underline text-n-blue-11"
          :class="{ 'font-mono': item.mono }"
        >
          {{ item.value }}
        </a>
        <span v-else :class="{ 'font-mono': item.mono }">{{ item.value }}</span>
      </dd>
    </div>
  </dl>
</template>
